import { Helper } from '../Helper';
export class RawIteratorForEachHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.rawIteratorForEachBase({
            each: (innerOptions) => {
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                sb.emitOp(node, 'OVER');
                sb.emitSysCall(node, 'Neo.Iterator.Key');
                this.each(innerOptions);
            },
        }));
    }
}

//# sourceMappingURL=RawIteratorForEachHelper.js.map
